define(
    'viewmodels/secured/libraries/empty',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, dataProvider, i19n) {

        var vm = new ViewModel(
        {
            id: '',
            name: '',
            notify: {},
            reload: {},
            emptyOption: ko.observable('0'),
            comboClick: {},
            i19n: i19n,
            isErrorVisible: ko.observable(false),
            errorCode: ko.observable()
        });

        vm.activate = function () {
            vm.emptyOption(0);
            vm.isErrorVisible(false);            
        };
        vm.attached = function () {
            $("#delete-library-default-option").prop("checked", true);
        };
        vm.emptyClick = function () {
            dataProvider.
            libraries
            .emptyLibrary(vm.id, vm.emptyOption())
            .done(function (result) {
                vm.notify('success', i19n.to.libraryemptied);
                //vm.reload();
                //vm.comboClick();

                location.reload();
            })
            .fail(function (e) {
                e.stopPropagation = true;

                //using phrase as no unique code is given by web api
                if (e.error[0].phrase.indexOf('The library cannot be emptied as it contains Checked Out documents') > -1) {
                    vm.isErrorVisible(true);
                    vm.errorCode(1);

                } else if (e.error[0].phrase.indexOf('The library cannot be emptied as it is not disabled') > -1) {
                    vm.isErrorVisible(true);
                    vm.errorCode(2);

                } else {
                    vm.notify(e.error);
                }
            });

        };
        vm.cancelClick = function () {
            vm.comboClick(vm.id);
        };
        vm.okClick = function () {
            vm.comboClick(vm.id);
        };

        return vm;
    }
);
